const getBoundingClientRect = node => {
  if (!(!node || node.nodeType !== 1)) return node.getBoundingClientRect?.();
};
export { getBoundingClientRect };